<template>
  <div>

<!--    <div id="login_container" style="width: 300px; height: 400px;"></div>-->

      <!-- 定义一个容器来显示微信登录二维码 -->
<!--      <div style="height: 500px;width: 500px;"  ref="loginContainer"></div>-->


  </div>
</template>

<script>
import axios from 'axios';
import { Head } from 'vue-head';
// importScripts('https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js')
export default {
  components: {
    Head,
  },
  data() {
    return {
      wxLoginObj: null,
    };
  },
  mounted() {
  this.redirectToWeixinLogin()
  },
  methods: {

      redirectToWeixinLogin() {
        const appid = 'wx1d9a459294b117e7';
        const redirect_uri = encodeURIComponent('https://yasubit.com/yasubit/users/wechat/callback');
        // const appid = 'wxf094fc7360e2b164';
        // const redirect_uri = encodeURIComponent('https://www.yasubit.com/wechat/callback');
        const responseType = 'code';
        const scope = 'snsapi_login';
        const state = 'STATE';

        // 构建请求路径
        const url = `http://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${responseType}&scope=${scope}&state=${state}#wechat_redirect`;

        // 重定向到微信登录页面
        window.location.href = url;
      }
    ,


  },

};
</script>

